import { SettingsIntegrationBase } from '@app/models/company/settings/integrations/integration-base.model';
import { SettingsIntegration } from '@app/models/company/settings/settings-integration.model';
import { IndeedIntegrationStatus } from '@applicant-tracker/enums/indeed-integration-status.enum';

export class IntegrationIndeed extends SettingsIntegrationBase {
    protected static _type = 'indeeds';

    protected static _resource = 'companyManagement/companies/:company/integrations/indeed';

    // TODO Indeed, new integration - rename isQuickApplyEnabled to isIndeedApplyEnabled
    protected static _serializeAttributes = ['isQuickApplyEnabled', 'sourceName'];

    get integration(): SettingsIntegration {
        return this.hasOne(SettingsIntegration, 'integration');
    }

    get isQuickApplyEnabled(): boolean {
        return this._attributes['isQuickApplyEnabled'];
    }

    set isQuickApplyEnabled(val: boolean) {
        this._attributes['isQuickApplyEnabled'] = val;
    }

    get sourceName(): string {
        return this._attributes['sourceName'];
    }

    set sourceName(val: string) {
        this._attributes['sourceName'] = val;
    }
}
